@if (currentWeather && !isLoading) {
  <vw-extendable-card [headerTemplate]="cardHeaderTemplate"
    [bodyTemplate]="cardBodyTemplate">
  <ng-template #cardHeaderTemplate>
    <div class="flex items-center w-full h-12">
      <div [style.background-color]="backgroundColor | HexToHsl" class="h-full flex items-center px-4 w-56 gap-2">
        <div class="w-8 h-full flex items-center justify-center shrink-0">
          <vw-icon-svg [iconUrl]="iconUrl"></vw-icon-svg>
        </div>
        <p class="text-sm font-medium whitespace-normal text-grey-900">
          {{ currentWeather.currentTemperature }}°c
        </p>
      </div>
      <div class="w-full h-full flex items-center mr-8">
        <p class="text-xs pl-3 text-gray-700">{{ title }}</p>
      </div>
    </div>
  </ng-template>
  <ng-template #cardBodyTemplate>
    <div class="w-full flex h-max p-4 justify-between items-end" [style.background-color]="backgroundColor | HexToHsl">
      <div class="w-2/3 h-full flex flex-col gap-2">
        <div class="flex flex-col gap-0.5">
          <h5 class="text-[16px] font-medium text-gray-800">
            {{currentDate | date: 'EEEE dd MMMM' | titlecase}}
          </h5>
          <p class="text-xs text-gray-700">{{ currentWeather.location }}</p>
        </div>
        <h3 class="text-[32px] font-semibold  text-[#451a03]">
          {{currentWeather.currentTemperature}}°c
        </h3>
        <div class="flex items-center gap-2">
          <ul class="flex items-center gap-2">
            <li class="flex items-center gap-[2px]">
              <span>
                <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-up.svg" additionalClasses="cursor-pointer"
                  width="16" height="16"></vw-icon-svg>
              </span>
              <span class="text-xs text-[#451a03]">
                {{currentWeather.maxTemperature}}°c</span>
            </li>
            <li class="flex items-center gap-[2px]">
              <span>
                <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-down.svg" additionalClasses="cursor-pointer"
                  width="16" height="16"></vw-icon-svg>
              </span>
              <span class="text-xs text-[#451a03]">{{currentWeather.minTemperature}}°c</span>
            </li>
            <li class="flex items-center gap-[2px]">
              <span>
                <vw-icon-svg iconUrl="/assets/svg/weather/weather-droplet.svg" additionalClasses="cursor-pointer"
                  width="16" height="16"></vw-icon-svg>
              </span>
              <span class="text-xs text-[#451a03]">{{currentWeather.totalPrecipitation}}mm</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="w-1/3 h-full flex items-end justify-end">
        <vw-icon-svg [iconUrl]="weatherImg" class="h-full" additionalClasses="cursor-pointer h-full" width="auto"
          height="100%"></vw-icon-svg>
      </div>
    </div>
  </ng-template>
  </vw-extendable-card>
}
@if (isLoading) {
  <vw-skeleton-loader [width]="'100%'" [height]="'48px'"
    [borderRadius]="'0.75rem'"></vw-skeleton-loader>
}